import { combineReducers } from 'redux';
import contact from './contact';
import personal from './personal';
import technical from './technical';
import loanInfo from './loanInfo';

export default combineReducers({
  personal,
  contact,
  loanInfo,
  technical,
});
